import React, { useEffect } from 'react';
import { Button } from '@/components/ui/button';
export default function OurStoryAndMission() {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.type = 'text/javascript';
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(link);
      document.head.removeChild(script);
    };
  }, []);
  const handleCalendlyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if ((window as any).Calendly) {
      (window as any).Calendly.initPopupWidget({
        url: 'https://calendly.com/mfloresdo/30min'
      });
    }
    return false;
  };
  return <section className="py-6 bg-background">
      <div className="container">
        <div className="max-w-4xl mx-auto">
          {}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-foreground leading-snug mb-4">About IronPeak Men's Health</h2>
            <div className="w-20 h-1 bg-primary mx-auto"></div>
          </div>

          {}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            {}
            <div>
              <h3 className="text-2xl md:text-3xl font-medium text-foreground leading-snug mb-6">Medicine for Men Who Want to Feel Like Themselves Again</h3>
              <div className="space-y-4">
                <p className="text-base md:text-lg text-foreground leading-relaxed">
                  IronPeak Men's Health is a physician-led telemedicine practice focused on helping men restore energy, confidence, performance, and long-term health—by identifying and treating root causes, not just symptoms. We work with men who are doing "everything right" but still feel off: low energy, stubborn weight gain, low libido, poor recovery, brain fog, or a sense that their performance has quietly declined over time. Our approach is medical, individualized, and built for long-term health—not quick fixes.
                </p>
              </div>
            </div>

            {}
            <div className="order-first lg:order-last">
              <div className="relative rounded-md overflow-hidden shadow-medium">
                <img src="https://relaxed-fowl.10web.cloud/wp-content/uploads/2025/10/telemedicine.png" alt="Telemedicine consultation" className="w-full h-96 object-cover object-[center_20%]" />
              </div>
            </div>
          </div>

          {}
          

          {}
          

          {}
          <div className="text-center mt-16">
            
            
          </div>
        </div>
      </div>
    </section>;
}